// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Typography,
} from '@mui/material';

export default function ErrorListDialog({ open, onClose, errors, onRowClick }) {
  const hasErrors = Array.isArray(errors) && errors.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth disablePortal>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        Erreurs de configuration
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {!hasErrors ? (
          <Typography variant="body2" sx={{ py: 2 }}>
            Aucune erreur de configuration détectée.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Nom</TableCell>
                <TableCell>Contexte</TableCell>
                <TableCell>Erreur</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {errors.map((err) => (
                <TableRow key={err.id}>
                  <TableCell>{err.typeLabel}</TableCell>
                  <TableCell>{err.name}</TableCell>
                  <TableCell>{err.context || '-'}</TableCell>
                  <TableCell>{err.message}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => onRowClick && onRowClick(err)} aria-label="Chercher">
                      <SearchIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}

ErrorListDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      cellId: PropTypes.string.isRequired,
      typeLabel: PropTypes.string,
      name: PropTypes.string,
      context: PropTypes.string,
      message: PropTypes.string,
      __kind: PropTypes.oneOf(['cell', 'transport']),
    })
  ),
  onRowClick: PropTypes.func,
};
